import { TType } from '../../hooks/useTranslation';
import * as Yup from 'yup';
import { investmentFields } from '../../utils/validation';
import { TransactionType } from '../../models/project';

export const returnNewUnitValidationSchema = (t: TType, isep?: boolean) =>
  Yup.object().shape({
    unitCategory: Yup.string().required('Unit Category is required').nullable(),
    projectName: Yup.string()
      .required(t('validationMessages.projectNameIsRequired'))
      .nullable(),
    unitType: Yup.string()
      .required(t('validationMessages.unitTypeIsRequired'))
      .nullable(),
    transactionType: Yup.string()
      .required(t('validation.transactionTypeRequired'))
      .nullable(),
    isLeasedFromAnotherIngkaCompany: Yup.string().when('transactionType', {
      is: TransactionType.LEASE,
      then: Yup.string().required(t('validation.leasedFromIngkaRequired')),
      otherwise: Yup.string().nullable().notRequired(),
    }),
    countryCode: Yup.string().required(t('validation.country')).nullable(),
    targetProjectStartDate: Yup.string()
      .required(t('validation.projectStartDate'))
      .nullable(),
    targetProjectEndDate: Yup.string()
      .required(t('validation.projectOpeningDate'))
      .nullable(),
    countryProjectResponsible: Yup.string()
      .required(t('validation.countryProjectResponsible'))
      .nullable(),
    stockedRangeAdjustment: Yup.string().nullable().notRequired(),
    storageCapacityAdjustment: Yup.string().nullable().notRequired(),
    truckFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    parcelFulfilmentCapacityAdjustment: Yup.string().nullable().notRequired(),
    automationLevel: Yup.string().nullable().notRequired(),
    ...investmentFields(t, isep),
    unifierId: Yup.string()
      .nullable()
      .matches(/^CMT\d{5}$/, {
        message: t('validationMessages.unifierIdWrongFormat'),
        excludeEmptyString: true,
      }),
  });

export const calculateTabErrors = (errors, isEdit) => {
  const tabErrors = {
    Required: 0,
    Project: 0,
    'Site/Unit': 0,
    Responsible: 0,
    Financials: 0,
    Solutions: 0,
  };
  if (errors.investments) {
    tabErrors.Financials = errors.investments.length;
  }

  for (const key in errors) {
    const type = errors[key].type;

    if (!isEdit && type?.includes('required')) {
      if (key !== 'isLeasedFromAnotherIngkaCompany') {
        tabErrors.Required++;
      }
    }

    if (['projectName', 'unifierId']?.includes(key)) {
      tabErrors.Project++;
    }

    if (
      [
        'unitCategory',
        'unitType',
        'transactionType',
        'countryCode',
        'isLeasedFromAnotherIngkaCompany',
      ].includes(key)
    ) {
      tabErrors['Site/Unit']++;
    }
    if (['countryProjectResponsible'].includes(key)) {
      tabErrors.Responsible++;
    }
    if (['solutions'].includes(key)) {
      tabErrors.Solutions++;
    }
  }

  return { ...tabErrors };
};
